module.exports = __webpack_public_path__ + "common/icon-arrow-right-gray-2569cad60fa08aa8bb29cac7ed63694a.svg";